export const UNO_URL = 'https://api.simulanis.io';
// export const UNO_URL = 'https://abmcpl-ar-vr-appsvcbackend.azurewebsites.net';
// export const UNO_URL = 'http://localhost:3003';
// export const UNO_URL = 'https://metaverse.hpcl.co.in:3003';
// export const UNO_URL = 'https://simulanis-uno-backend-backup-uat.azurewebsites.net';

// export const applicationId = "cc9d5c2c-4c4f-4c1f-a62a-823a38e0ddb6";    //2D LMS
export const applicationId = "e9dfc406-b05b-4bfe-a254-2dc4007a3363";      // XR

export const defaultLogo = "https://cdn.simulanis.io/sso/logos/obsys.png";

// export const 2D_APP_Id = "cc9d5c2c-4c4f-4c1f-a62a-823a38e0ddb6";   //2D LMS
// export const XR_App_Id = "e9dfc406-b05b-4bfe-a254-2dc4007a3363";   //XR LMS